/**
 * In-flight guard of quick-mark writes (2026-10b §4.3, 2026-10c §2). Until a quick mark's
 * `createBlock` settles the mode is still armed, so a second click, drag range or tile drop
 * would write a second block. One guard is shared by every lane and by the tile drag: a write
 * from any of them blocks the others until it settles.
 */
let busy = false;

/** True while a quick-mark write is in flight. */
export function isQuickMarkWriteBusy(): boolean {
  return busy;
}

/** Claim the guard; false when another quick-mark write is still in flight. */
export function beginQuickMarkWrite(): boolean {
  if (busy) return false;
  busy = true;
  return true;
}

export function endQuickMarkWrite(): void {
  busy = false;
}

/** Test helper: forget an in-flight write left over by a test that never settled it. */
export function resetQuickMarkGuard(): void {
  busy = false;
}
